<script lang="ts" setup>
const props = defineProps({
  attributes: {
    default: () => [],
    type: Array as PropType<string[]>,
  },
})

const { getCompanyAttributes } = useApiAttributes()

const finalAttributes = computed(() => {
  const results: ApiAttribute[] = []
  const companyAttributes = getCompanyAttributes({ version: 'v2' })

  for (const attribute of props.attributes) {
    const found = getAttribute(attribute, companyAttributes)

    if (found) {
      results.push(found)
    }
  }

  return results
})

function getAttribute(attributeToFind: string, attributes: ApiAttribute[]): ApiAttribute | undefined {
  for (const attribute of attributes) {
    if (attribute.description === attributeToFind) {
      return attribute
    }

    if (attribute.attributes) {
      const found = getAttribute(attributeToFind, attribute.attributes)

      if (found) {
        return found
      }
    }
  }
}
</script>

<template>
  <ApiAttributes :attributes="finalAttributes" />
</template>
